import { FC } from 'react';
import { Typography } from 'antd';
import styled from 'styled-components';
import dayjs from 'dayjs';
import { useTranslation } from 'react-i18next';
import Section from '~/layouts/Section ';
import { DocumentInput } from '~/components';
import { KsaReviewResult } from '~/types/ksa/KsaReviewResult';
import DecisionField from '~/pages/ksa/review/components/DecisionField';
import TextAreaField from '~/components/fields/TextAreaField';
import colors from '~/constants/colors';
import { NameFn } from '~/utils/buildNamePath';
import Form from '~/components/WizardForm';

interface Props {
  nameFn: NameFn;
  record: KsaReviewResult;
}

const ReviewResult: FC<Props> = (props) => {
  const { record, nameFn } = props;

  const { t } = useTranslation('ksaReview');
  return (
    <>
      <Section formItemFirst>
        <TitleContainer>
          <Typography.Title level={5}>{t('Review results').toUpperCase()}</Typography.Title>
          <Typography.Paragraph style={{ color: colors.grey[600] }}>
            {t('by')} {record.agentName} {dayjs(record.date).format('DD.MM.YYYY HH:mm')}
          </Typography.Paragraph>
        </TitleContainer>
        {record.decision ? (
          <Typography.Paragraph>
            <DecisionField
              label={t('Decision on the application:')}
              value={t(`reviewResult.${record.decision}`)}
              result={record.decision}
            />
          </Typography.Paragraph>
        ) : undefined}
        {record.files ? (
          <Typography.Paragraph>
            <DocumentInput
              name=""
              maxCount={record.files.length}
              value={record.files}
              multiple={false}
              noRemove
              readonly
            />
          </Typography.Paragraph>
        ) : undefined}
        <Typography.Paragraph>
          {record.reviewComment && <TextAreaField>{record.reviewComment}</TextAreaField>}
        </Typography.Paragraph>
      </Section>
      <Form.Item name={nameFn('uid')} hidden />
      <Form.Item name={nameFn('agentName')} hidden />
      <Form.Item name={nameFn('date')} hidden />
      <Form.Item name={nameFn('files')} hidden />
      <Form.Item name={nameFn('decision')} hidden />
      <Form.Item name={nameFn('reviewComment')} hidden />
    </>
  );
};

const TitleContainer = styled.div`
  display: flex;
  justify-content: space-between;
`;

export default ReviewResult;
